export const habilitar = () => {
    document.getElementsByClassName('devolucion')[0].classList.toggle('aplicaDevolucion');
};

export const habilitarProcesoPlurianual = () => {
    document.getElementsByClassName('procesoPluriannual')[0].classList.toggle('aplicaProcesoPlurianual');
}